/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertyDiagnosticsMetadata } from './PropertyDiagnosticsMetadata';
import {
    PropertyDiagnosticsMetadataFromJSON,
    PropertyDiagnosticsMetadataFromJSONTyped,
    PropertyDiagnosticsMetadataToJSON,
    PropertyDiagnosticsMetadataToJSONTyped,
} from './PropertyDiagnosticsMetadata';
import type { SupplierMapping } from './SupplierMapping';
import {
    SupplierMappingFromJSON,
    SupplierMappingFromJSONTyped,
    SupplierMappingToJSON,
    SupplierMappingToJSONTyped,
} from './SupplierMapping';
import type { RateFetchSummary } from './RateFetchSummary';
import {
    RateFetchSummaryFromJSON,
    RateFetchSummaryFromJSONTyped,
    RateFetchSummaryToJSON,
    RateFetchSummaryToJSONTyped,
} from './RateFetchSummary';

/**
 * 
 * @export
 * @interface PropertyDiagnosticsResponse
 */
export interface PropertyDiagnosticsResponse {
    /**
     * 
     * @type {PropertyDiagnosticsMetadata}
     * @memberof PropertyDiagnosticsResponse
     */
    metadata?: PropertyDiagnosticsMetadata;
    /**
     * 
     * @type {Array<SupplierMapping>}
     * @memberof PropertyDiagnosticsResponse
     */
    supplierMappings?: Array<SupplierMapping>;
    /**
     * 
     * @type {Array<RateFetchSummary>}
     * @memberof PropertyDiagnosticsResponse
     */
    rateFetchHistory?: Array<RateFetchSummary>;
}

/**
 * Check if a given object implements the PropertyDiagnosticsResponse interface.
 */
export function instanceOfPropertyDiagnosticsResponse(value: object): value is PropertyDiagnosticsResponse {
    return true;
}

export function PropertyDiagnosticsResponseFromJSON(json: any): PropertyDiagnosticsResponse {
    return PropertyDiagnosticsResponseFromJSONTyped(json, false);
}

export function PropertyDiagnosticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyDiagnosticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'metadata': json['metadata'] == null ? undefined : PropertyDiagnosticsMetadataFromJSON(json['metadata']),
        'supplierMappings': json['supplier_mappings'] == null ? undefined : ((json['supplier_mappings'] as Array<any>).map(SupplierMappingFromJSON)),
        'rateFetchHistory': json['rate_fetch_history'] == null ? undefined : ((json['rate_fetch_history'] as Array<any>).map(RateFetchSummaryFromJSON)),
    };
}

export function PropertyDiagnosticsResponseToJSON(json: any): PropertyDiagnosticsResponse {
    return PropertyDiagnosticsResponseToJSONTyped(json, false);
}

export function PropertyDiagnosticsResponseToJSONTyped(value?: PropertyDiagnosticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metadata': PropertyDiagnosticsMetadataToJSON(value['metadata']),
        'supplier_mappings': value['supplierMappings'] == null ? undefined : ((value['supplierMappings'] as Array<any>).map(SupplierMappingToJSON)),
        'rate_fetch_history': value['rateFetchHistory'] == null ? undefined : ((value['rateFetchHistory'] as Array<any>).map(RateFetchSummaryToJSON)),
    };
}

